angular.module('app').factory('userService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        return {
            getCurrentUserName: function () {
                return restAngular.
                    one("UserManagement/GetCurrentUserName").
                    get()
            },
            getUserRoles: function () {
                return restAngular.
                    one("user/rolesCanBeCreated").
                    get()
            },
            createUser: function (user) {
                return restAngular.
                    one("user/create").
                    post("", user)
            },
            editUser: function (user) {
                return restAngular.
                    one("user/change").
                    post("", user)
            },
            getAllUsers: function (requestData) {
                return restAngular.
                    one("user/get").
                    customGET(param(requestData))
            },
            getUserById: function (userId) {
                return restAngular.
                    one("user/get").
                    customGET(param(userId))
            },
            deleteUserById: function (userId) {
                return restAngular.
                    one("user/delete").
                    customGET(param(userId))
            },




            getSysDate: function () {
                return restAngular.
                    one("setting/GetSysDate").
                    get()
            },
            getSetting: function () {
                return restAngular.
                    one("setting/GetSetting").
                    get()
            },
            getUserSettings: function () {
                return restAngular.
                    one("account/GetPartnerSecuritySetting").
                    get()
            },
            saveSetting: function (settings) {
                return restAngular.
                    one("setting/saveSetting").
                    post(settings)
            },
            changeLanguage: function () {

            },
            login: function (loginInfo) {
                return restAngular.
                    one("User/login").
                    post("", loginInfo)
            },
            logout: function () {
                return restAngular.
                    one("User/logout").
                    post()
            },
            changePassword: function (password) {
                return restAngular.
                    one("User/changePassword").
                    post("", password)
            }
        }
    }
]);